import styled from 'styled-components';

const StyledInput = styled.input`
	width: 100%;
	height: 50px;
	border-radius: 10px;
	padding: 15px;
	font-size: 16px;
	border: 1px solid #ccd2d9;
	margin-top: 14px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	StyledInput,
};
